export default __webpack_public_path__ + "static/media/arrow-dropup.f0e57ca2.svg";